<script lang="ts">
	import type { ComponentProps } from 'svelte';

	import * as Sidebar from '$lib/components/ui/sidebar';

	import type { Chat } from '$lib/client/db/schema';

	import CommandBar from '../command-bar/command-bar.svelte';
	import FooterMenu from './footer-menu.svelte';
	import HeaderMenu from './header-menu.svelte';
	import PrimaryMenu from './primary-menu.svelte';
	import QuickMenu from './quick-menu.svelte';
	import RecentChatsMenu from './recent-chats-menu.svelte';
	import SettingsMenu from './settings-menu.svelte';

	let {
		recentChats,
		hasChangelogUpdates,
		ref = $bindable(null),
		...restProps
	}: {
		recentChats: Chat[];
		hasChangelogUpdates: boolean;
	} & ComponentProps<typeof Sidebar.Root> = $props();
</script>

<Sidebar.Root bind:ref {...restProps} class="border-border/50">
	<Sidebar.Rail />

	<Sidebar.Header class="border-b border-border/10">
		<HeaderMenu />
		<CommandBar />
	</Sidebar.Header>

	<Sidebar.Content>
		<Sidebar.Group>
			<Sidebar.GroupLabel class="sr-only">Quick Actions</Sidebar.GroupLabel>
			<Sidebar.GroupContent>
				<QuickMenu />
			</Sidebar.GroupContent>
		</Sidebar.Group>

		<Sidebar.Group>
			<Sidebar.GroupLabel>Collections</Sidebar.GroupLabel>
			<Sidebar.GroupContent>
				<PrimaryMenu />
			</Sidebar.GroupContent>
		</Sidebar.Group>

		<Sidebar.Group>
			<Sidebar.GroupLabel>Settings</Sidebar.GroupLabel>
			<Sidebar.GroupContent>
				<SettingsMenu />
			</Sidebar.GroupContent>
		</Sidebar.Group>

		<Sidebar.Group>
			<Sidebar.GroupLabel>Recent Chats</Sidebar.GroupLabel>
			<Sidebar.GroupContent>
				<RecentChatsMenu chats={recentChats} />
			</Sidebar.GroupContent>
		</Sidebar.Group>
	</Sidebar.Content>

	<Sidebar.Footer class="border-t border-border/10">
		<FooterMenu {hasChangelogUpdates} />
		<!-- <UserMenu /> -->
	</Sidebar.Footer>
</Sidebar.Root>
